import { Box, Stack, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import CustomButton from '../../../components/form/custom-button';
import { useNavigate } from "react-router-dom";
import { useCallback } from "react";
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

const heroLocales = "hero";

const HeroDescription = () => {
    const theme = useTheme();
    const {t} = useTranslation();

    const navigate = useNavigate();

    const contact = useCallback(() => {
        navigate('/contact');
    }, []);

    return (
        <>
            <Stack
                direction='column'
                justifyContent='center'
                alignItems={{xs: 'center', md: 'start'}}
            >
                {/* Title */}
                <Typography
                    fontWeight={900}
                    fontSize={{xs: 32, md: 60}}
                    lineHeight={1.25}
                    textAlign={{xs: 'center', md: 'left'}}
                    data-aos="fade-up"
                >
                    {t(`${heroLocales}.title`)}
                </Typography>

                {/* Description */}
                <Typography
                    fontWeight={400}
                    fontSize={{xs: 14, md: 16}}
                    lineHeight={1.5}
                    letterSpacing={1}
                    textAlign={{xs: 'center', md: 'left'}}
                    sx={{
                        pt: {xs: 1, md: 2},
                        pb: {xs: 3, md: 5}
                    }}
                    color={theme.palette.text.secondary}
                    data-aos="fade-up"
                    data-aos-delay="100"
                >
                    {t(`${heroLocales}.description`)}
                </Typography>

                <Box
                    data-aos="fade-up"
                    data-aos-delay="200"
                >
                    <CustomButton 
                        label={t(`${heroLocales}.action`)}
                        onClick={contact}
                        endIcon={<KeyboardArrowRightIcon />}
                        needAnimation
                    />
                </Box>
            </Stack>
        </>
    );
}

export default HeroDescription;